import PropTypes from 'prop-types';
// form
import {useFormContext, Controller} from 'react-hook-form';
// @mui
import {InputAdornment, MenuItem, Select, TextField} from '@mui/material';
import {numberWithCommas, toEnglishNumber} from "../../utils/formatNumber";
import {useTranslation} from "react-i18next";
import Num2persian from "num2persian";
import {tomanPrice} from "../../utils/functions";
import React from "react";
import CustomMenuItem from "../CustomMenuItem";

// ----------------------------------------------------------------------

export default function RHFPercentAmountField({typeName,convert, valueName,sx, ...other}) {
    const {control, setValue, getValues, watch} = useFormContext();
    const {t} = useTranslation()
    return (
        <Controller
            name={valueName}
            control={control}
            render={({field, fieldState: {error}}) => (
                <TextField {...field} fullWidth error={!!error} helperText={error?.message} {...other}
                           value={numberWithCommas(getValues(valueName))}
                           sx={sx}
                           onChange={(event) => {
                               let onlyNums = event.target.value.replace(/(?!,)[^0-9]$/g, '');
                               onlyNums = toEnglishNumber(onlyNums).replaceAll(',', '')
                               if (getValues(typeName) === 'percent') {
                                   if ((parseInt(onlyNums) || 0) <= 100) {
                                       setValue(valueName, onlyNums)
                                   }
                               } else {
                                setValue(valueName,onlyNums.replaceAll(',', ''))
                            }
                           }}
                           InputProps={{
                               endAdornment:
                                   <InputAdornment position="end">
                                       <>
                                        {
                                            getValues(typeName) === 'amount' && 
                                            convert ? `${Num2persian(tomanPrice(getValues(valueName)))} تومان` : 'درصد'
                                        }
                                       <Select 
                                            
                                            size="small"
                                            value={watch(typeName)}
                                            onChange={(e) => {
                                                setValue(typeName, e.target.value);
                                                setValue(valueName, '')
                                            }}
                                        >
                                            <CustomMenuItem value={'percent'}>
                                                درصدی
                                            </CustomMenuItem>
                                            <CustomMenuItem value={'amount'}>
                                                مبلغی
                                            </CustomMenuItem>
                                        </Select>
                                       </>
                                   </InputAdornment>,
                           }}
                />
            )}
        />
    );
}



